import axios from "axios";
import costCenters from "../../models/centrosDeCosto/costCenters";
import moment from "moment";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getCostCenters() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/cscostos`, { headers }).then(({ data }) =>
      data.map((item) => {
        return costCenters.fromJson(item);
      })
    );
  }

  getCostCentersId(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/cscostos/${id}`, { headers })
      .then(({ data }) => data);
  }

  getLiqModelos() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/modelos`, { headers }).then(({ data }) =>
      data.map((item) => {
        return models.fromJson(item);
      })
    );
  }

  addCostCenter(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      nombre: data.nombre,
    };

    if (data.liqModelos && data.liqModelos.length > 0) {
      payload.liqModelos = data.liqModelos;
    }

    if (data.relojes && data.relojes.length > 0) {
      payload.relojes = data.relojes;
    }

    return axios.post(`${url}/cscostos`, payload, { headers });
  }

  deleteCostCenter(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/cscostos/${id}`, { headers });
  }

  editCostCenter(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      nombre: data.nombre,
    };

    if (data.liqModelos && data.liqModelos.length > 0) {
      payload.liqModelos = data.liqModelos;
    }

    if (data.relojes && data.relojes.length > 0) {
      payload.relojes = data.relojes;
    }
    return axios
      .patch(`${url}/cscostos/${data.id}`, payload, { headers })
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  addClockToCostCenter(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      csCostoId: data.csCostoId,
      relojId: Number(data.relojId),
      fecDesde: data.fecDesde + "T00:00:00.000Z",
      codRegisEx: data.codRegExt,
    };

    if (data.fecHasta) {
      payload.fecHasta =
        moment(data.fecHasta).add(1, "days").format("YYYY-MM-DD") +
        "T00:00:00.000Z";
    }

    return axios.post(`${url}/cscostos/relojes`, payload, { headers });
  }

  deleteClockToCostCenter(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(
      `${url}/cscostos/reloj/${data.csCostoId}&${data.relojId}&${data.fecDesde}&${data.codRegisEx}`,
      { headers }
    );
  }

  editClockToCostCenter(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const formattedOldFecDesde = moment(
      data.oldItems.fecDesde,
      "DD-MM-YYYY"
    ).format("YYYY-MM-DD");
    const payload = {
      fecDesde: data.fecDesde + "T00:00:00.000Z",
      codRegisEx: data.codRegisEx,
    };
    if (data.fecHasta) {
      payload.fecHasta =
        moment(data.fecHasta).add(1, "days").format("YYYY-MM-DD") +
        "T00:00:00.000Z";
    }
    return axios
      .patch(
        `${url}/cscostos/reloj/${data.csCostoId}&${data.relojId}&${
          formattedOldFecDesde + "T00:00:00.000Z"
        }&${data.oldItems.codRegisEx}`,
        payload,
        { headers }
      )
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }
}

export default service;
